import { css } from "@/utils/css";

type Message = {
    message: string;
    isReply: boolean;
};

type Props = {
    messages: Message[];
};

export function Messages({ messages }: Props) {
    return (
        <div className={css("messages")}>
            {messages.map((msg, i) => (
                <div key={i} className={css("message", msg.isReply ? "is-reply" : "")}>
                    <div className={css("bubble atml-msg-html")} dangerouslySetInnerHTML={{ __html: msg.message }} />
                </div>
            ))}
        </div>
    );
}
